/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems, getArrayItemsNull, getCellImage } from '../../utils/FormatFunctions';
import { SelectFilter } from '../../components/inputs/filters/select';
import { useAuth } from '../../providers/auth';

export function TutorsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users?group_id=3`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const groupIds = user?.group?.id;

  const { requestApi: reqApiInstitution, data: dataInstitution } = useFetch(
    `${baseApiUrl}/institutions`,
  );
  const { requestApi: reqApiSecretary, data: dataSecretary } = useFetch(
    `${baseApiUrl}/secretaries`,
  );
  const { requestApi: reqApiModules, data: dataModules } = useFetch('/v1/admin/classes');
  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'image', label: 'Imagem' },
    { name: 'name', label: 'Nome' },
    { name: 'email', label: 'Email' },
    { name: 'institutions', label: 'Instituições' },
    { name: 'school_classes', label: 'Módulos' },
    { name: 'secretaries', label: 'Secretarias' },
  ];

  useEffect(() => {
    reqApiInstitution('get');
    reqApiSecretary('get');
  }, []);

  return (
    <Box>
      <PageTitle>Tutores</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 6}
        loading={loading}
        rowActions={{ show: false, edit: groupIds !== 6, delete: groupIds !== 6 }}
        formatColum={[
          {
            field: 'image',
            formatField: values => getCellImage(values, true),
          },
          {
            field: 'institutions',
            formatField: getArrayItems,
          },
          {
            field: 'secretaries',
            formatField: getArrayItems,
          },
          {
            field: 'school_classes',
            formatField: getArrayItemsNull,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
          {
            name: 'institution_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar instituição',
            isSearchable: true,
            onInputChange: value => {
              reqApiInstitution('get', { params: { search: value } });
            },
            options: [
              ...(dataInstitution?.data?.map(item => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
          {
            name: 'secretary_id',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar secretaria',
            isSearchable: true,
            onInputChange: value => {
              reqApiSecretary('get', { params: { search: value } });
            },
            options: [
              ...(dataSecretary?.data?.map(item => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
          {
            name: 'school_class',
            filterComponent: SelectFilter,
            placeholder: 'Selecionar módulo',
            isSearchable: true,
            onInputChange: value => {
              reqApiModules('get', { params: { search: value } });
            },
            options: [
              ...(dataModules?.data?.map(item => ({
                label: item?.name,
                value: item?.id,
              })) ?? []),
            ],
          },
        ]}
      />
    </Box>
  );
}
